export default "__VITE_ASSET__c7276556__"